// src/modals/getInsuranceData.js

import accidental_insurance from "./accidental_insurance";
import bike_packages from "./Bike_packages";
import car_packages from "./Car_packages";
import health_insurance from "./health_insurance";
import agri_experts from "./Agri_experts";
import crop_insurance from "./crop_insurance";
import mobile_insurance from "./mobile_insurance";

const getInsuranceData = (type) => {
  switch (type) {
    case "car":
      return new car_packages().getAllItems();
    case "bike":
      return new bike_packages().getAllItems();
    case "accidental":
      return new accidental_insurance().getAllItems();
    case "health":
      return new health_insurance().getAllItems();
    case "mobile":
      return new mobile_insurance().getAllItems();
    case "home":
      return new agri_experts().getAllItems();
    case "crops":
      return new crop_insurance().getAllItems();
    default:
      return [];
  }
};

export default getInsuranceData;
